export * from './erinnerung-abgemeldet.interface';
